export default "__VITE_ASSET__Dlqkgodq__"